import * as etiProducts from '@eti/products';
import { productConstants } from '@eti/products';
import type {
  BoundNew,
  BundleProduct,
  ExtraProduct,
  ProductNew,
  TravelerNew,
  TripType,
} from '@eti/schema-types';

export type OrderTypePostbooking = {
  addedAncillaryBundles: BundleProduct['options'];
  availableExtraProducts: ExtraProduct[];
  bounds: BoundNew[] | [];
  extraProducts: ProductNew[];
  travelers: TravelerNew[];
  tripId: string;
  isMultiStop: boolean;
  tripType?: TripType;
};

const extraProducts = {
  ...productConstants,
};

const travelerInsuranceProducts: number[] = [
  extraProducts.TRAVEL_INSURANCE_INSIDE_EU.id,
  extraProducts.TRAVEL_INSURANCE_OUTSIDE_EU.id,
];

const getProductSellSpecification = (order: OrderTypePostbooking, id: number) => {
  const productSpecs = order.availableExtraProducts.find(
    (availableExtraProduct) => String(availableExtraProduct.id) === String(id),
  );

  return productSpecs?.sellSpecification;
};

export const getProductSpecificTexts = (order: OrderTypePostbooking, id: number) => {
  const productSpecs = order.availableExtraProducts.find(
    (availableExtraProduct) => String(availableExtraProduct.id) === String(id),
  );

  return productSpecs?.productSpecificTexts;
};

const sortByOrderedIds = (a: { id: number }, b: { id: number }) => {
  const orderedIds = [
    625, 624, 6, 623, 2003, 2001, 2000, 62, 64, 201, 5001, 260, 5102, 270, 5003, 83, 2002,
  ];
  const aIndex = orderedIds.indexOf(a.id);
  const bIndex = orderedIds.indexOf(b.id);
  if (aIndex === -1 && bIndex === -1) {
    return 0;
  }
  if (aIndex === -1) {
    return 1;
  }
  if (bIndex === -1) {
    return -1;
  }
  return aIndex - bIndex;
};

export const getAvailableExtraProducts = ({ order }: { order: OrderTypePostbooking }) => {
  if ((order && !Object.keys(order)?.length) || !order?.availableExtraProducts) {
    return [];
  }

  const availableExtraProductsInOrder = (productId: number) =>
    order.availableExtraProducts?.some(
      (availableExtraProduct) => String(availableExtraProduct?.id) === String(productId),
    );

  const products = Object.values(extraProducts)
    .filter((product) => product?.id !== undefined && availableExtraProductsInOrder(product?.id))
    ?.map(({ code, id, component: ExtraProductComponent }) => {
      const sellSpecification = getProductSellSpecification(order, id);
      const productSpecificTexts = getProductSpecificTexts(order, id);

      const isTravelerInsuranceProduct = travelerInsuranceProducts.includes(id);

      return {
        code,
        id,
        confirmation: { isEnabled: isTravelerInsuranceProduct },
        sellSpecification,
        productSpecificTexts,
        component: <ExtraProductComponent layoutType={etiProducts.ProductCardLayoutType.Main} />,
      };
    })
    ?.sort(sortByOrderedIds);

  return products;
};
